import { IAppState } from "models";
import { appSettingsReducer } from "./appSettingsReducer";
import { pageReducer } from "./pageReducer";
import { userSettingsReducer } from "./userSettingsReducer";


export const appReducer = (app: IAppState, action) => ({
	page: pageReducer(app.page, action),
	userSettings: userSettingsReducer(app.userSettings, action),
	appSettings: appSettingsReducer(app.appSettings, action),
})